import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useSelector } from "react-redux";
import { ContentHeaderTitle } from "~/components/PageHeader/ContentHeaderTitle";
import { BOARD_BLURB_TITLE } from "~/constants/testIDs";
import { centralizedBoardTitleSelector } from "~/store/centralizedBoard/selectors";
export const PublicBoardHeaderTitle = /*#__PURE__*/ memo(()=>{
    const title = useSelector(centralizedBoardTitleSelector);
    if (!title) return null;
    return /*#__PURE__*/ _jsx(ContentHeaderTitle, {
        "data-testid": BOARD_BLURB_TITLE,
        children: title
    });
});
PublicBoardHeaderTitle.displayName = "PublicBoardHeaderTitle";
